import {Fragment, ReactNode} from 'react';

import styled, {css} from 'styled-components';

import {flexCenter} from '~/shared/theme/FlexLayout';
import {bodyBold} from '~/shared/theme/typography';
import PieButton from '~/shared/theme/pie/PieButton';

export const OPEN_CHECKOUT_BUTTON_HEIGHT = 100;

const BackgroundWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${OPEN_CHECKOUT_BUTTON_HEIGHT}px;
  background-color: ${({theme}) => theme.colors.surface};
  z-index: ${({theme}) => theme.zIndex.openCartButton};
  box-shadow: ${({theme}) => theme.shadows.elevation04};
  padding: 16px;
`;

const fixedButtonStyles = css`
  position: fixed;
  padding: 14px 16px;
  bottom: 16px;
  left: 16px;
  right: 16px;
  z-index: ${({theme}) => theme.zIndex.openCartButton};
`;

const staticButtonStyles = css`
  width: 100%;
`;

const ButtonComponent = styled(PieButton).attrs({
  'data-test-id': 'open-checkout-button',
  variant: 'primaryXL',
})<{fixed?: boolean}>`
  ${bodyBold}
  padding: 10px 16px;
  ${({fixed}) => (fixed ? fixedButtonStyles : staticButtonStyles)}

  .button-content-container {
    width: 100%;
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
  ${flexCenter}
`;

type OpenCartButtonProps = {
  onPayment: () => void;
  fixed?: boolean;
  children?: ReactNode;
  className?: string;
  withBackground?: boolean;
};

const OpenCheckoutButton = ({onPayment, children, className, withBackground}: OpenCartButtonProps) => {
  const WrapperComponent = withBackground ? BackgroundWrapper : Fragment;

  return (
    <WrapperComponent>
      <ButtonComponent onClick={onPayment} className={className} fixed={!withBackground}>
        <ContentWrapper>{children}</ContentWrapper>
      </ButtonComponent>
    </WrapperComponent>
  );
};

export default OpenCheckoutButton;
